// import {useState} from 'react';
import { Box} from '@mui/material';
import {ReactComponent as RoadmapLine} from "../static/icons/Expanded Roadmap Line (Map View).svg"
import RoadmapCards from './RoadmapCards';

export default function MapComponent({questions}) {
    
    return (
        <Box 
        data-cy="roadmap-map-box"
        sx={{
            position: 'relative',
            width: '100%',
            height: '100%',
            whiteSpace: 'nowrap',
            overflowX: 'auto',
        }}>

            <Box 
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex', 
                justifyContent: 'center',
                alignItems: 'center',
                minWidth: 'max-content',
                backgroundImage: "url('/icons/Expanded Roadmap Line (Map View).svg')",
                backgroundRepeat: 'repeat-x',
                backgroundPosition: 'center',
                gap: '50px'
            }}>

                {questions.map((item, index) => {

                    return <RoadmapCards key={index} data={item} description={item.Problem} cardPosition={index % 2} type={"map"} index={index}/>  

                })}

            </Box>

        </Box>
    )


}
